
   <div class="jumbotron">
   
	<!-- <div class="col-md-6"> -->
	 <div class="navbar-brand">
		 <img src="../../assets/images/Logo.png" alt="Nature">
		 
	   </div>
	   <!-- <div class="settings">
		 <p>Hello</p>
	   </div> -->
	   <div class="settings" (click)="logout()"> Logout <i class="fas fa-sign-out-alt" style="color: #86b437;"></i> </div>
	   <div class="settings" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Setting
		 <i class="fas fa-cog" style="color: #86b437;">
		 </i>
   </div>
   <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
	 <a class="dropdown-item" [routerLink]="['/profile']">User Profile</a>
	 <a class="dropdown-item" [routerLink]="['/feedback']">Feedback</a>
	 <!-- <a class="dropdown-item" href="#">Another</a> -->
   </div>
 
   
	<!-- </div> -->
	<!-- <div class="col-md-6">
		

</div> -->
</div>


<nav class="navbar navbar-expand-sm bg-dark navbar-dark">
 <!-- <a class="navbar-brand" href="#">Navbar</a> -->
 <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
   <span class="navbar-toggler-icon"></span>
 </button>
 <div class="collapse navbar-collapse" id="collapsibleNavbar">
   <ul class="navbar-nav">
	<li class="nav-item">
		<a class="nav-link" [routerLink]="['/startmeeting']" style="color: #fff;"><i class="fas fa-users" style="color: #fff; margin-right: 10px;" aria-hidden="true"></i>Start Meeting</a>	
	  </li>
	  <li class="nav-item">
		<a class="nav-link" [routerLink]="['/joinmeeting']" style="color: #fff;"><i class="fas fa-users" style="color: #fff; margin-right: 10px;" aria-hidden="true"></i>Join Meeting</a>	
	  </li>




	 <li class="nav-item">
	   <a class="nav-link" [routerLink]="['/dashboard']" style="color: #fff;"><i class="fas fa-users" style="color: #fff; margin-right: 10px;" aria-hidden="true"></i>Conference</a>	
	 </li>
	 <li class="nav-item">
	   <a class="nav-link" [routerLink]="['/webinar']" style="color: #fff;"><i class='fas fa-chalkboard-teacher' style="color: #fff;margin-right: 10px;"></i>Webinar</a>
	 </li>
	 <li class="nav-item" >
	   <a class="nav-link" [routerLink]="['/contact']" style="color: #fff;"><i class="fas fa-address-book" style="color: #fff; margin-right: 10px;" aria-hidden="true"></i>Contact</a>
	 </li>  

   </ul>
 </div>  
</nav>
